import { render } from "./cpt-icon-ring.vue?vue&type=template&id=00b6d4b2"
import script from "./cpt-icon-ring.vue?vue&type=script&lang=js"
export * from "./cpt-icon-ring.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../.tjp/v1/FEharBh6/xdkj/daping/node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.20_vue@3.4.20_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__